export default __webpack_public_path__ + "static/media/PopupIcons_AuditInformation_White.7d0bc7eb.svg";